import { Fragment } from 'react';
import { formatTime } from '../../../../utils/utilities';
import { MTInspectionReportData, Project } from '../../../../utils/models';

import GridItem from '../general/gridItem';
import css from '../pdf.module.scss';

interface MTInspectionReportProps extends MTInspectionReportData {
	projectDetails: Project;
}

const MTInspectionReport = (props: MTInspectionReportProps) => {
	return (
		<Fragment>
			<div className="container-fluid overflow-hidden">
				<div className="row">
					<div className="col">
						<GridItem
							title="Client:"
							value={props.projectDetails.organisation.organisationName}
						/>

						<GridItem title="Location:" value={props.projectDetails.location} />

						<GridItem
							title="Facility:"
							value={props.projectDetails.facilityName}
						/>

						<GridItem
							title="Tag No.:"
							value={props.projectDetails.equipmentTag}
						/>
					</div>

					<div className="col">
						<GridItem
							title="Date:"
							value={formatTime(props.projectDetails.createdAt)}
						/>

						<GridItem
							title="Report No.:"
							value={props.projectDetails.documentNumber}
						/>

						<GridItem
							title="Work Order No.:"
							value={props.workOrderNo as string}
						/>

						<GridItem title="Material:" value={props.material as string} />
					</div>
				</div>
			</div>

			<div className={css['title-grid']}></div>

			<div className="container-fluid overflow-hidden">
				<div className="row">
					<div className="col">
						<GridItem
							title="Surface condition:"
							value={props.surfaceCondition}
						/>

						<GridItem title="Stage of test:" value={props.testStage} />

						<GridItem title="Equipment:" value={props.equipment} />

						<GridItem title="Method:" value={props.method} />
					</div>

					<div className="col">
						<GridItem
							title="Magnetic Medium used:"
							value={props.magneticMediumUsed}
						/>

						<GridItem title="Current used:" value={props.currentUsed} />

						<GridItem
							title="Background contrast medium used:"
							value={props.bgContrastMediumUsed}
						/>

						<GridItem title="Technique:" value={props.technique} />
					</div>
				</div>

				<GridItem title="Ref Std:" value={props.refStd} />

				<GridItem title="Acceptance  Std:" value={props.acceptanceStd} />

				<GridItem title="Procedure No:" value={props.procedureNo} />
			</div>

			<div>
				<div className={css['title-grid'] + ' text-uppercase font-weight-bold'}>
					Summary
				</div>
				<div className={css['title-grid-value']}>{props.summary}</div>
			</div>

			<div>
				<div className={css['title-grid'] + ' text-uppercase font-weight-bold'}>
					Remarks
				</div>
				<div
					className={css['title-grid-value']}
					style={{ backgroundColor: props.remarks?.color }}
				>
					{props.remarks?.name}
				</div>
			</div>
		</Fragment>
	);
};

export default MTInspectionReport;
